export enum UnitStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PAUSE = 'PAUSE'
}
